import { BackButton } from "../BackButton/BackButton";
import styles from "./header.css";

/**
 * Header component for displaying a customizable header section.
 *
 * @param {Object} props - Component properties.
 * @param {boolean} [props.back=false] - Indicates if a back button should be displayed.
 * @param {string} [props.backPath] - Path URL for the back button navigation.
 * @param {boolean} [props.replaceLink=false] - Determines whether the back button uses `replace` for link navigation.
 * @param {string} [props.title] - Main title text displayed in the header.
 * @param {string} [props.subtitle] - Subtitle text displayed in the header below the title.
 * @param {boolean} [props.swapHeadlines=false] - If set to true, swaps the order of title and subtitle.
 * @param {React.ReactNode} props.children
 * @param {boolean} [props.isDarkMode=false] - Determines whether the header uses a dark theme.
 * @param {boolean} [props.hasBorder=true] - Indicates if the header container has a visible border.
 * @returns {React.ReactElement} Rendered Header component.
 */
const Header = ({
  back = false,
  backPath,
  replaceLink = false,
  title,
  subtitle,
  swapHeadlines = false,
  children,
  isDarkMode = false,
  hasBorder = true,
}) => {
  const header = () => {
    return (
      <h1 className={styles.title({ isDarkMode })} key={"h1"}>
        {title}
      </h1>
    );
  };
  const subheader = () => {
    return (
      <p className={styles.subtitle({ isDarkMode })} key={"h2"}>
        {subtitle}
      </p>
    );
  };
  const headerArray = [title && header(), subtitle && subheader()];

  return (
    <header className={styles.container({ isDarkMode, hasBorder })}>
      {back && (
        <BackButton
          theme={isDarkMode ? "dark" : "light"}
          backPath={backPath}
          replaceLink={replaceLink}
        />
      )}
      <div className={styles.headlineContainer}>
        {swapHeadlines ? headerArray.reverse() : headerArray}
      </div>
      <div className={styles.childrenContainer}>
        <div>{children}</div>
      </div>
    </header>
  );
};

export default Header;
